<template>
  <div class="adminActivities">
    <Navigation showPromoterNav="true"></Navigation>
    <div class="row m-t-6">
      <div class="col-md-12 m-t-2">
        <h2>Actividades</h2>
      </div>
      <div class="col-md-12">
        <table class="table">
          <thead>
            <tr>
              <th>
                <input v-model="nameFilter" v-on:input="setNameFilter()" type="text" placeholder="nome">
              </th>
              <th>
                <input v-model="promoterFilter" v-on:input="setPromoterFilter()" type="text" placeholder="Promotor">
              </th>
              <th>email</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="activity in activities">
              <td>
                <span v-if="activity.translations[language]">
                  {{activity.translations[language].name}}
                  <a :href="'/' + language + '/activity/'+ activity.slug" target="_blank"><i class="fa fa-external-link" aria-hidden="true"></i></a>
                </span>
                <span v-if="!activity.translations[language]">
                  Tradução indisponivel
                </span>
              </td>
              <td>{{activity.promoter.data.company_name}}</td>
              <td>
                {{activity.promoter.data.user.data.email}}
              </td>
              <td>
                <button class="btn" v-bind:class="{'btn-primary': activity.is_highlight}" v-on:click="setHighlight(({is_highlight: !activity.is_highlight, id: activity.id}))">Destaque</button>
                <span v-if="activity.approved">
                  <i class="fa fa-circle text-success" aria-hidden="true"></i><button class="btn btn-danger btn-sm"i v-on:click="setApproved({approved: false, id: activity.id})">desaprovar</buttoN>
                </span>
                <span v-if="!activity.approved">
                  <i class="fa fa-circle text-danger" aria-hidden="true"></i>
<button class="btn btn-default btn-sm" v-on:click="setApproved(({approved: true, id: activity.id}))">aprovar</button>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState } from 'vuex';
import Navigation from '../Admin/Navigation/Navigation';

export default {
  name: 'AdminActivities',
  components: {
    Navigation,
  },
  data() {
    return {
      nameFilter: '',
      promoterFilter: '',
    };
  },
  methods: {
    setNameFilter() {
      this.$store.dispatch('adminActivitiesSetNameFilter', this.nameFilter);
    },
    setPromoterFilter() {
      this.$store.dispatch('adminActivitiesSetPromoterFilter', this.promoterFilter);
    },
    setApproved(val) {
      this.$store.dispatch('adminActivititesSetApproved', val);
    },
    setHighlight(val) {
      this.$store.dispatch('adminActivititesSetHighlight', val);
    },
  },
  created() {
    this.$store.dispatch('adminGetActivities');
  },
  computed: {
    ...mapState({
      activities: state => state.adminActivities.filteredActivities,
      language: state => state.language,
    }),
  },
  watch: {

  },
};
</script>

<style lang="scss" scoped>
.adminActivities {
  padding-bottom: 100px;
}
</style>




// WEBPACK FOOTER //
// AdminActivities.vue?3c9b44fe